/* ============================================================
   Carta Noor · Panel Size and Sample on the product page

   The store carries four panel lengths so customers pay only for
   the paper they need. Choosing a length BEFORE saying how tall
   your wall is is backwards, so the Panel Size picker is hidden
   and the configurator chooses the length from the wall height.
   The picker still exists in the DOM because the theme needs it
   to resolve a variant; it is just driven for the customer.

   Samples. From 21 Sep 2026 a sample is a SIZE ("Sample 20 in /
   51 cm") offered in every finish, so the customer picks the
   finish first and then "Full panels" or "Sample". Before that
   date a sample was a Wallpaper Type ("Sample") with no finish.
   This script supports BOTH shapes (LEGACY below) so the theme
   can be published before the product data is migrated.

   ?intent=sample in the URL (the quiz's "Order sample" link)
   opens the page with the sample already selected.

   No backslashes in this file: it has been deployed through a
   GraphQL block string before, which breaks them silently.
   ============================================================ */
(function () {
  'use strict';

  /* Localised UI strings come from window.CN_T (rendered in layout/theme.liquid
     from locales/*.json). The English fallback keeps this file working alone. */
  var CN_T = window.CN_T || {};
  function tx(k, fb, v) {
    var s = CN_T[k] || fb;
    if (v) { Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(String(v[n])); }); }
    return s;
  }

  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var DEFAULT_SIZE = '120 in / 305 cm';   /* safest common ceiling if nobody configures */

  function isSample(s) { return String(s || '').toLowerCase().indexOf('sample') >= 0; }

  var sizeGroup = null, typeGroup = null;
  Array.prototype.forEach.call(document.querySelectorAll('.cn-variant-group'), function (g) {
    var el = g.querySelector('.cn-variant-group__label');
    var label = el ? el.textContent.trim() : '';
    /* Match by option POSITION (data-cn-pos, set in main_product.liquid) so this
       keeps working when the option names are translated. Names stay as a fallback. */
    var pos = g.getAttribute('data-cn-pos');
    if (pos === '2' || label === 'Panel Size') sizeGroup = g;
    if (pos === '1' || label === 'Wallpaper Type') typeGroup = g;
  });
  if (!sizeGroup) return;

  sizeGroup.classList.add('cnc-opt-hidden');

  function radios(g) { return g ? g.querySelectorAll('.cn-variant-radio') : []; }
  function checkedVal(g) {
    var r = g ? g.querySelector('.cn-variant-radio:checked') : null;
    return r ? r.value : '';
  }
  function currentSize() { return checkedVal(sizeGroup); }
  function currentType() { return checkedVal(typeGroup); }
  function setRadio(g, val) {
    var rs = radios(g);
    for (var i = 0; i < rs.length; i++) {
      if (rs[i].value === val) {
        if (!rs[i].checked) {
          rs[i].checked = true;
          rs[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }
  function setSize(val) { return setRadio(sizeGroup, val); }
  function firstOf(g, wantSample) {
    var rs = radios(g);
    for (var i = 0; i < rs.length; i++) if (isSample(rs[i].value) === wantSample) return rs[i].value;
    return '';
  }
  function panelSizeValues() {
    var out = [], rs = radios(sizeGroup);
    for (var i = 0; i < rs.length; i++) if (!isSample(rs[i].value)) out.push(rs[i].value);
    return out;
  }

  var SAMPLE_SIZE = firstOf(sizeGroup, true);
  var SAMPLE_TYPE = firstOf(typeGroup, true);   /* non-empty only in the LEGACY shape */
  var LEGACY = !!SAMPLE_TYPE;
  var HAS_SAMPLE = LEGACY || !!SAMPLE_SIZE;

  /* In the LEGACY shape "Sample" sits among the finishes. The mode
     switch below replaces it, so its pill is hidden. */
  if (LEGACY) {
    Array.prototype.forEach.call(radios(typeGroup), function (r) {
      if (!isSample(r.value)) return;
      var lab = typeGroup.querySelector('label[for="' + r.id + '"]');
      if (lab) lab.hidden = true;
    });
  }

  function inSample() { return isSample(currentSize()) || (LEGACY && isSample(currentType())); }

  var lastPanelSize = '';

  function toPanels() {
    if (LEGACY && isSample(currentType())) setRadio(typeGroup, firstOf(typeGroup, false));
    if (!setSize(lastPanelSize || DEFAULT_SIZE)) {
      var vals = panelSizeValues();
      if (vals.length) setSize(vals[vals.length - 1]);
    }
  }
  function toSample() {
    var c = currentSize();
    if (c && !isSample(c)) lastPanelSize = c;
    if (LEGACY) setRadio(typeGroup, SAMPLE_TYPE);
    if (SAMPLE_SIZE) setSize(SAMPLE_SIZE);
  }

  /* ---------- the one-line panel note (unchanged wording) ---------- */
  var note = document.createElement('div');
  note.className = 'cnc-sizenote';
  note.innerHTML =
    '<span class="cnc-sizenote__t">' + tx('pds_note_t', 'Panel width 76 cm · length matched to your wall') + '</span>' +
    '<span class="cnc-sizenote__b">' + tx('pds_note_b', 'We print in four lengths — 244, 274, 305 and 366 cm — and pick the ' +
    'shortest that covers your wall, so you are not paying for paper you will cut off. ' +
    'The price above is for a 305 cm panel; a lower wall costs less. ') +
    '<button type="button" class="cnc-sizenote__a" data-cnc-openfromnote>' + tx('pds_note_a', 'Customise to see yours') + '</button></span>';
  sizeGroup.parentNode.insertBefore(note, sizeGroup.nextSibling);

  var link = note.querySelector('[data-cnc-openfromnote]');
  if (link) {
    link.addEventListener('click', function () {
      var t = document.getElementById('CNCfgTrigger');
      if (t) t.click();
    });
  }

  if (!HAS_SAMPLE) {
    setSize(DEFAULT_SIZE);
    return;
  }

  /* ---------- sample note ---------- */
  var sampleNote = document.createElement('div');
  sampleNote.className = 'cnc-sizenote';
  sampleNote.style.display = 'none';
  sampleNote.innerHTML =
    '<span class="cnc-sizenote__t">' + tx('pds_sample_t', 'Printed sample · 76 × 51 cm (30 × 20 in)') + '</span>' +
    '<span class="cnc-sizenote__b">' +
    (LEGACY
      ? tx('pds_sample_legacy', 'A full-width printed sample of this design, posted free worldwide. ')
      : tx('pds_sample_new', 'A full-width printed sample of this design in the finish chosen above, posted free worldwide. ')) +
    tx('pds_sample_tail', 'Hold it against your wall, in your light, before you order panels.') + '</span>';
  note.parentNode.insertBefore(sampleNote, note.nextSibling);

  /* ---------- Full panels / Sample switch ---------- */
  var style = document.createElement('style');
  style.textContent =
    '.cnc-mode{margin:0 0 20px}' +
    '.cnc-mode__label{font-family:var(--cn-f-display);font-size:14px;font-weight:300;color:var(--cn-parchment);letter-spacing:.04em;margin-bottom:10px}' +
    '.cnc-mode__opts{display:flex;flex-wrap:wrap;gap:8px}' +
    '.cnc-mode__btn{font-family:var(--cn-f-body);font-size:11px;font-weight:300;letter-spacing:.08em;color:var(--cn-sand);' +
      'background:transparent;border:.5px solid rgba(196,149,58,.2);border-radius:0;padding:8px 16px;cursor:pointer;' +
      'transition:all var(--cn-t-fast,.2s) ease}' +
    '.cnc-mode__btn:hover{border-color:rgba(196,149,58,.5);color:var(--cn-ivory)}' +
    '.cnc-mode__btn[aria-pressed="true"]{border-color:var(--cn-gold);color:var(--cn-ivory);background:rgba(196,149,58,.08)}' +
    '.cnc-mode__btn:focus-visible{outline:1px solid var(--cn-gold);outline-offset:2px}';
  document.head.appendChild(style);

  var mode = document.createElement('div');
  mode.className = 'cnc-mode';
  mode.innerHTML =
    '<div class="cnc-mode__label">' + tx('pds_mode_label', 'Order') + '</div>' +
    '<div class="cnc-mode__opts" role="group" aria-label="' + tx('pds_mode_aria', 'Order full panels or a sample') + '">' +
    '<button type="button" class="cnc-mode__btn" data-cnc-mode="panel">' + tx('pds_mode_panels', 'Full panels') + '</button>' +
    '<button type="button" class="cnc-mode__btn" data-cnc-mode="sample">' + tx('pds_mode_sample', 'Sample · 76 × 51 cm') + '</button>' +
    '</div>';
  if (typeGroup && typeGroup.parentNode) typeGroup.parentNode.insertBefore(mode, typeGroup.nextSibling);
  else sizeGroup.parentNode.insertBefore(mode, sizeGroup);

  var btnPanel = mode.querySelector('[data-cnc-mode="panel"]');
  var btnSample = mode.querySelector('[data-cnc-mode="sample"]');

  function render() {
    var s = inSample();
    btnPanel.setAttribute('aria-pressed', s ? 'false' : 'true');
    btnSample.setAttribute('aria-pressed', s ? 'true' : 'false');
    /* style.display, not the hidden attribute: .cnc-sizenote sets its
       own display in cn-configurator.css, which overrides [hidden]. */
    note.style.display = s ? 'none' : '';
    sampleNote.style.display = s ? '' : 'none';
    /* The wall configurator is for panels only. cn-configurator.js
       hides its own trigger for a LEGACY sample but cannot see a
       sample chosen by size, so it is hidden here as well. This runs
       after the configurator's own change handler, so it wins. */
    var trig = document.getElementById('CNCfgTrigger');
    if (trig) { trig.hidden = s; trig.style.display = s ? 'none' : ''; }
    var chip = document.getElementById('CNCfgChip');
    if (chip && s) chip.hidden = true;
  }

  btnPanel.addEventListener('click', function () { toPanels(); setTimeout(render, 0); });
  btnSample.addEventListener('click', function () { toSample(); setTimeout(render, 0); });

  /* A finish chosen while a LEGACY sample is selected means panels:
     the old sample had no finish to attach it to. In the new shape
     every finish has its own sample, so nothing needs to move. */
  Array.prototype.forEach.call(radios(typeGroup), function (r) {
    r.addEventListener('change', function () {
      setTimeout(function () {
        if (LEGACY && !isSample(currentType()) && isSample(currentSize())) toPanels();
        render();
      }, 0);
    });
  });
  Array.prototype.forEach.call(radios(sizeGroup), function (r) {
    r.addEventListener('change', function () { setTimeout(render, 0); });
  });

  /* ---------- initial state ---------- */
  var wantSample = false;
  try { wantSample = new URLSearchParams(window.location.search).get('intent') === 'sample'; } catch (e) {}

  if (wantSample) toSample();
  else if (!inSample()) setSize(DEFAULT_SIZE);   /* land on the safe default, not the shortest panel */
  render();
})();
